module.exports = __webpack_public_path__ + "static/media/3.1c89818f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/Assets/Images/Artists/07/projects/01/3.jpg
// module id = 421
// module chunks = 0